import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { APPLICATIONS } from '../data/products';
import Breadcrumbs from '../components/Breadcrumbs';
import ChapterBreak from '../components/ChapterBreak';
import { Reveal } from '../components/Reveal';
import HospitalityEstimator from '../components/HospitalityEstimator';

const HERO_IMG = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_modularoom-design/artifacts/9zd8mcz0_6b5cca98-d5ef-4b59-a728-583b38b016b3.webp';

const KEYS = ['luxury-resorts','boutique-hotels','glamping','rentals'];

export default function Hospitality() {
  const items = APPLICATIONS.filter((a) => KEYS.includes(a.id));
  return (
    <main data-testid="hospitality-page" className="bg-white text-[#111]">
      <Helmet>
        <title>Hospitality Solutions | MODULAROOM</title>
        <meta name="description" content="Signature Capsule Suites and Studio Suites for luxury resorts, boutique hotels, glamping cabins and Airbnb rentals. Add modular resort rooms in weeks, not months, with MODULAROOM." />
        <link rel="canonical" href="https://modularoom.com/hospitality" />
      </Helmet>
      <section className="pt-40 md:pt-56 pb-16 max-w-[1440px] mx-auto px-6 md:px-12">
        <Breadcrumbs items={[{label:'Home', to:'/'}, {label:'Applications'}, {label:'Hospitality'}]} />
        <h1 className="mt-14 font-display text-6xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] max-w-5xl">
          Signature suites<br/><span className="italic text-black/40">for luxury hospitality.</span>
        </h1>
        <p className="mt-10 max-w-xl text-[17px] text-black/60 leading-[1.75]">
          MODULAROOM was designed with resort developers, boutique hoteliers and glamping operators in mind. Add unforgettable modular resort rooms in weeks, with the finish level guests expect from a signature property.
        </p>
      </section>

      <ChapterBreak src={HERO_IMG} chapter="Hospitality" minHeight="60svh" />

      <section className="pb-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 md:gap-x-16 gap-y-24">
          {items.map((a, i) => (
            <Reveal key={a.id}>
              <div id={a.id.split('-')[0]} className="group">
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img src={a.image} alt={a.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.045]" />
                  <div className="absolute top-5 left-5 text-[10px] tracking-[0.28em] uppercase text-white/90">/{String(i+1).padStart(2,'0')}</div>
                </div>
                <div className="mt-6 font-display text-3xl md:text-4xl tracking-tight">{a.title}</div>
                <div className="mt-3 text-black/65 leading-relaxed max-w-md">{a.caption}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <HospitalityEstimator />

      <section className="bg-[#111] text-white py-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="text-[10px] tracking-[0.32em] uppercase text-[#C7A36A]">For hospitality developers</div>
            <h2 className="mt-6 font-display text-4xl md:text-6xl tracking-tight leading-[1.02]">Add signature keys to your property.</h2>
          </div>
          <Link to="/contact#book" className="md:col-span-4 md:justify-self-end inline-flex items-center gap-2 rounded-full bg-white text-[#111] px-7 py-3.5 text-[12px] tracking-[0.2em] uppercase hover:bg-[#C7A36A] hover:text-white transition-colors">Speak with our team</Link>
        </div>
      </section>
    </main>
  );
}
